import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { useField } from "react-final-form";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface ResetOptimisedRouteButtonProps {
  loading: boolean;
  handleFetchOptimisedRoute: () => void;
}

const ResetOptimisedRouteButton: React.FC<ResetOptimisedRouteButtonProps> = ({
  loading,
  handleFetchOptimisedRoute,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const formRoutesChangedField = useField("formRoutesChanged");

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResetOptimisedRoute = () => {
    formRoutesChangedField.input.onChange(false);
    handleFetchOptimisedRoute();
    handleClose();
  };

  return (
    <>
      <Button
        label="Reset To System Optimised Route"
        onClick={handleOpenDialog}
        disabled={loading}
      />

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Reset To System Optimised Route
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            <>
              This action will reset all existing routes to the system's
              recommended route, including unassigned locations.
              <br />
              Are you sure you want to reset to system the optimised route?
            </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleResetOptimisedRoute}
            color="primary"
            label="Reset"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResetOptimisedRouteButton;
